import LocalDbSyncManager from "./local-db-sync-manager";

/**
 * Holds live LocalDbSyncManager instances by the database name.
 * Data structure: `{$dbName: LocalDbSyncManager}`
 */
const dbs = {};

export const get = (dbName) => {
  if (dbs[dbName]) {
    return dbs[dbName];
  }

  dbs[dbName] = new LocalDbSyncManager(dbName);
  return dbs[dbName];
};